import { isEmpty } from "lodash-es";
import { handleApi } from "../common";

const API_CONSTANTS = {
  recommendv2: "/api/invest/recommendv2",
  fetchMfPaymentData: "/api/invest?version=v2",
  fetchNfoRecommendations: "/api/invest/nfo/recommendations",
  fetchNfoFundDetails: (isin) => `/api/invest/nfo/byisin?isin=${isin}`,
  getFundPurchaseLimit: (investType, isins) =>
    `/api/mf/funddata/${investType}?type=isin&isins=${isins}`,
  verifyReferralCode: "/api/checkpromocode",
};

export const fetch_mf_recommended_funds = async ({ Api, params, token }) => {
  const url = API_CONSTANTS.recommendv2;
  const response = await Api.get(url, params, {}, token);
  const result = handleApi(response);
  return result;
};

export const fetch_nfo_recommendations = async ({ Api, token }) => {
  const url = API_CONSTANTS.fetchNfoRecommendations;
  const response = await Api.get(url, {}, {}, token);
  const result = handleApi(response);
  return result;
};

export const get_fund_purchase_limit = async ({
  Api,
  token,
  investType,
  isins,
}) => {
  const url = API_CONSTANTS.getFundPurchaseLimit(investType, isins);
  const response = await Api.get(url, {}, {}, token);
  const result = handleApi(response);
  return result;
};

export const fetch_nfo_fund_details = async ({ Api, isin, token }) => {
  const url = API_CONSTANTS.fetchNfoFundDetails(isin);
  const response = await Api.get(url, {}, {}, token);
  return handleApi(response);
};

export const fetch_mf_payment_data = async ({ Api, body = {}, token, platform = '' }) => {
  let url = API_CONSTANTS.fetchMfPaymentData;
  if (!isEmpty(platform)) {
    url = `${API_CONSTANTS.fetchMfPaymentData}&platform=${platform}`
  }
  const response = await Api.post(url, body, {}, token);
  const result = handleApi(response);
  return result;
};

export const verifyReferralCode = async ({ Api, body = {}, token }) => {
  const url = API_CONSTANTS.verifyReferralCode;
  const response = await Api.get(url, body, {}, token);
  const result = handleApi(response);
  return result;
};
